module.exports = __webpack_public_path__ + "img/Monique Carstens.ea52dfb7.png";